import React, {FC} from "react"
import {X} from "react-bootstrap-icons"
import {useTranslation} from "next-i18next"
import Typography from "../../reusable/Typography/Typography"
import PropTypes from "prop-types"
import {StockStatus} from "../../bikeDetails/BikeDetails"

type Props ={
	activeFilters: {key:string, activeItems: any[]}[],
	removeFilterByParamKey: (key: string, slug: string)=> void,
	removeAllFilters: ()=> void
}

const SelectedFiltersDesktop: FC<Props> = ({activeFilters, removeFilterByParamKey, removeAllFilters}): React.ReactElement => {
	const {t} = useTranslation("filters")
	const isFiltersActive = activeFilters?.some(cat => cat?.activeItems?.length > 0)

	return (
		isFiltersActive ?
			<div className="row bg-light p-3 mb-2 justify-content-start align-items-baseline">
				<div className="col-auto">
					<Typography onClick={removeAllFilters}
						variant="bodyLgBold"
						semanticTag="span"
						className="nav-link-black pointer">
						{t("clear_all_filters", {ns: "filters"})}
					</Typography>
				</div>
				<div className="col">
					<ul className="row list-unstyled mb-0">
						{activeFilters?.map(({key, activeItems}) => {
							return activeItems?.map(item =>
								<li onClick={() => removeFilterByParamKey(key, item.slug)}
									key={item.id + item.slug}
									className="col-auto px-1 pointer">
									<Typography className="me-2"
										variant="bodyLg"
										semanticTag="span">
										{Object.values(StockStatus).map(value => value.toLowerCase().includes(item.slug)) ? t(item.name) : item.name}
									</Typography>
									<span className="me-2">
										<X size={25}/>
									</span>
								</li>)
						})}
					</ul>
				</div>
			</div> : null
	)
}

SelectedFiltersDesktop.propTypes = {
	activeFilters: PropTypes.array.isRequired,
	removeFilterByParamKey: PropTypes.func.isRequired,
	removeAllFilters: PropTypes.func.isRequired
}

export default SelectedFiltersDesktop
